import {
    Order_ClosedOrdersForUser as orderForUser,
    Account_GetUserData as get,
    Account_UpdateUserData as update,
    Account_ChangePassword as changePw,
    Account_PasswordForgotten as  reset,
    Account_PasswordForgotten2 as forgotten
} from './backend'


const getOrderForUser = async (page) => {
    let { data } = await orderForUser({
        page: page
    });
    return data;
}

const updateUser = async(userdata) => {
    let {data} = await update({
        userData:  userdata
    });
    return data;
}

const getUser = async() => {
    let {data} = await get();
    return data;
}

const changeUserPassword = async (oldpwd,newpwd) => {
    let {data} = await changePw({
        req:  {
            oldPassword: oldpwd,
            newPassword: newpwd
        }
    });
    return data;
}

const resetPassword = async (email, token, pwd) => {
    let {data} = await reset({
        cmd: {
            email: email,
            token: token,
            newPassword: pwd
        }
    })
    return data;
}

const passwordForgotten = async (email) => {
    let {data} = await forgotten({
        cmd: {
            email: email 
        }
    })
    return data;
}

export default {
    getOrderForUser,
    updateUser,
    getUser,
    changeUserPassword,
    resetPassword,
    passwordForgotten
}